'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.BANKA = exports.POKLADNA = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:22:50Z                      #

// ##############################################################

/**
 * Typ vratky.
 */

var POKLADNA = exports.POKLADNA = 'POKLADNA';

var BANKA = exports.BANKA = 'BANKA';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [POKLADNA, BANKA];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, POKLADNA, { caption: '' }), (0, _defineProperty3.default)(_params, BANKA, { caption: '' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvYXBpL2dlbi9wcm94aW9hcGkvVHlwVnJhdGt5LmpzeCJdLCJuYW1lcyI6WyJnZXRDYXB0aW9uIiwiUE9LTEFETkEiLCJCQU5LQSIsInZhbHVlcyIsInBhcmFtcyIsImNhcHRpb24iLCJ2YWx1ZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztRQXVDZ0JBLFUsR0FBQUEsVTs7OztBQXZDaEI7QUFDQTs7QUFFQTs7QUFFQTs7QUFFQTs7QUFFQTs7QUFFQTs7OztBQUlPLElBQU1DLDhCQUFXLFVBQWpCOztBQUVBLElBQU1DLHdCQUFRLE9BQWQ7O0FBRVA7OztBQUdPLElBQU1DLDBCQUFTLENBQ2xCRixRQURrQixFQUVsQkMsS0FGa0IsQ0FBZjs7QUFLUDs7O0FBR0EsSUFBTUUsK0RBQ0RILFFBREMsRUFDVSxFQUFDSSxTQUFTLEVBQVYsRUFEViwwQ0FFREgsS0FGQyxFQUVPLEVBQUNHLFNBQVMsRUFBVixFQUZQLFdBQU47O0FBS0E7Ozs7QUFJTyxTQUFTTCxVQUFULENBQW9CTSxLQUFwQixFQUEyQjtBQUM5QixTQUFPRixPQUFPRSxLQUFQLEVBQWNELE9BQXJCO0FBQ0giLCJmaWxlIjoiVHlwVnJhdGt5LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQENvbmZcbi8vICNoYXNEb2M9dHJ1ZVxuXG4vLyAjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjI1xuXG4vLyAjICAgICAgICAgICAgIEdFTkVST1ZBTsOdIEvDk0QsIE5FTU9ESUZJS09WQVQhISEhICAgICAgICAgICAgICAjXG5cbi8vICMgICAgICAgICAgICAgICAgICAyMDI1LTAxLTA3VDIyOjIyOjUwWiAgICAgICAgICAgICAgICAgICAgICAjXG5cbi8vICMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjXG5cbi8qKlxuICogVHlwIHZyYXRreS5cbiAqL1xuXG5leHBvcnQgY29uc3QgUE9LTEFETkEgPSAnUE9LTEFETkEnO1xuXG5leHBvcnQgY29uc3QgQkFOS0EgPSAnQkFOS0EnO1xuXG4vKipcbiAqIFNlem5hbSB2xaFlY2ggaG9kbm90LlxuICovXG5leHBvcnQgY29uc3QgdmFsdWVzID0gW1xuICAgIFBPS0xBRE5BLFxuICAgIEJBTktBXG5dO1xuXG4vKipcbiAqIE1hcGEgZW51bXUgbmEgb2JqZWt0IHMgcG9kcm9ibm9zdG1pIG8gZW51bXUuXG4gKi9cbmNvbnN0IHBhcmFtcyA9IHtcbiAgICBbUE9LTEFETkFdOiB7Y2FwdGlvbjogJyd9LFxuICAgIFtCQU5LQV06IHtjYXB0aW9uOiAnJ31cbn07XG5cbi8qKlxuICogTmHEjXRlbsOtIHBvcGlza3UgZW51bXUuXG4gKiBAcmV0dXJuIHBvcGlzZWsgZW51bXVcbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGdldENhcHRpb24odmFsdWUpIHtcbiAgICByZXR1cm4gcGFyYW1zW3ZhbHVlXS5jYXB0aW9uO1xufSJdfQ==